import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  answer_call_form_type: {
    errorCount: 0,
  },
  right_resp_form_type: {
    errorCount: 0,
  },
  registration_form_type: {
    errorCount: 0,
  },
  tanfdt_form_type: {
    errorCount: 0,
  },
  tanfwpcoop_form_type: {
    errorCount: 0,
  },
  childcareonly_form_type: {
    errorCount: 0,
  },
  cctanf_form_type: {
    errorCount: 0,
  },
  screennamevr_form_type: {
    errorCount: 0,
  },
  screennamepw_form_type: {
    errorCount: 0,
  },
  csallprograms_form_type: {
    errorCount: 0,
  },
  csauthrep_form_type: {
    errorCount: 0,
  },
  cssummaryscreen_form_type: {
    errorCount: 0,
  },
  reportingpage_form_type: {
    errorCount: 0,
  },
  indemoscreen_form_type: {
    errorCount: 0,
  },
  citidentitylist_form_type: {
    errorCount: 0,
  },
  householdstatuslist_form_type: {
    errorCount: 0,
  },
  relationshiplist_form_type: {
    errorCount: 0,
  },
  pregnancylist_form_type: {
    errorCount: 0,
  },
  otherprogramlist_form_type: {
    errorCount: 0,
  },
  noncompliancelist_form_type: {
    errorCount: 0,
  },
  timelimitsummary_form_type: {
    errorCount: 0,
  },
  purchasepreparelist_form_type: {
    errorCount: 0,
  },
  schoolattlist_form_type: {
    errorCount: 0,
  },
  livingarrangement_form_type: {
    errorCount: 0,
  },
  noncustparentlist_form_type: {
    errorCount: 0,
  },
  medcondlist_form_type: {
    errorCount: 0,
  },
  emplistinclist_form_type: {
    errorCount: 0,
  },
  resourcelist_form_type: {
    errorCount: 0,
  },
  expenselist_form_type: {
    errorCount: 0,
  },
  dcexpenselist_form_type: {
    errorCount: 0,
  },
  mdexpenselist_form_type: {
    errorCount: 0,
  },
  mdcareexpenselist_form_type: {
    errorCount: 0,
  },
  childcareneedlist_form_type: {
    errorCount: 0,
  },
  pcscheduledlist_form_type: {
    errorCount: 0,
  },
  famplanchildcare_form_type: {
    errorCount: 0,
  },
  tanfsuspensionbased_form_type: {
    errorCount: 0,
  },
  dvsass_form_type: {
    errorCount: 0,
  },
  icebt_form_type: {
    errorCount: 0,
  },
  expeditedstatus_form_type: { errorCount: 0 },
  icmawrs_form_type: {
    errorCount: 0,
  },
  verificationslist_form_type: {
    errorCount: 0,
  },
  todo_form_type: {
    errorCount: 0,
  },
  runedbc_form_type: {
    errorCount: 0,
  },
  narrative_form_type: {
    errorCount: 0,
  },
  interview_form_data: [],
  tempData_form_type: {},
  alert_msg: false,
  pdf_files: [],
  agent_name: "",
  isSuccess: false,
};

const trackerSlice = createSlice({
  name: "tracker",
  initialState,
  reducers: {
    update_isSuccess: (state, action) => {
      state.isSuccess = {
        ...state.isSuccess,
        ...action.payload,
      };
    },
    update_temp_data_form_type: (state, action) => {
      state.tempData_form_type = {
        ...state.tempData_form_type,
        ...action.payload,
      };
    },

    update_pdf_files_type: (state, action) => {
      state.pdf_files.push(action.payload);
    },
    update_answer_call_form: (state, action) => {
      state.answer_call_form_type = {
        ...state.answer_call_form_type,
        ...action.payload,
      };
    },
    update_right_resp_form: (state, action) => {
      state.right_resp_form_type = {
        ...state.right_resp_form_type,
        ...action.payload,
      };
    },
    update_registration_form: (state, action) => {
      state.registration_form_type = {
        ...state.registration_form_type,
        ...action.payload,
      };
    },
    update_tanfdt_form: (state, action) => {
      state.tanfdt_form_type = {
        ...state.tanfdt_form_type,
        ...action.payload,
      };
    },
    update_tanfwpcoop_form: (state, action) => {
      state.tanfwpcoop_form_type = {
        ...state.tanfwpcoop_form_type,
        ...action.payload,
      };
    },
    update_childcareonly_form: (state, action) => {
      state.childcareonly_form_type = {
        ...state.childcareonly_form_type,
        ...action.payload,
      };
    },
    update_cctanf_form: (state, action) => {
      state.cctanf_form_type = {
        ...state.cctanf_form_type,
        ...action.payload,
      };
    },
    update_screenvr_form: (state, action) => {
      state.screennamevr_form_type = {
        ...state.screennamevr_form_type,
        ...action.payload,
      };
    },
    update_screenpw_form: (state, action) => {
      state.screennamepw_form_type = {
        ...state.screennamepw_form_type,
        ...action.payload,
      };
    },
    update_csallprograms_form: (state, action) => {
      state.csallprograms_form_type = {
        ...state.csallprograms_form_type,
        ...action.payload,
      };
    },
    update_csauthrep_form: (state, action) => {
      state.csauthrep_form_type = {
        ...state.csauthrep_form_type,
        ...action.payload,
      };
    }, //cssummaryscreen_form_type
    update_cssummaryscreen_form: (state, action) => {
      state.cssummaryscreen_form_type = {
        ...state.cssummaryscreen_form_type,
        ...action.payload,
      };
    }, //reportingpage_form_type
    update_reportingpage_form: (state, action) => {
      state.reportingpage_form_type = {
        ...state.reportingpage_form_type,
        ...action.payload,
      };
    }, //indemoscreen_form_type
    update_indemoscreen_form: (state, action) => {
      state.indemoscreen_form_type = {
        ...state.indemoscreen_form_type,
        ...action.payload,
      };
    }, //citidentitylist_form_type
    update_citidentitylist_form: (state, action) => {
      state.citidentitylist_form_type = {
        ...state.citidentitylist_form_type,
        ...action.payload,
      };
    }, //householdstatuslist_form_type
    update_householdstatuslist_form: (state, action) => {
      state.householdstatuslist_form_type = {
        ...state.householdstatuslist_form_type,
        ...action.payload,
      };
    }, //relationshiplist_form_type
    update_relationshiplist_form: (state, action) => {
      state.relationshiplist_form_type = {
        ...state.relationshiplist_form_type,
        ...action.payload,
      };
    }, //pregnancylist_form_type
    update_pregnancylist_form: (state, action) => {
      state.pregnancylist_form_type = {
        ...state.pregnancylist_form_type,
        ...action.payload,
      };
    }, //otherprogramlist_form_type
    update_otherprogramlist_form: (state, action) => {
      state.otherprogramlist_form_type = {
        ...state.otherprogramlist_form_type,
        ...action.payload,
      };
    }, //noncompliancelist_form_type
    update_noncompliancelist_form: (state, action) => {
      state.noncompliancelist_form_type = {
        ...state.noncompliancelist_form_type,
        ...action.payload,
      };
    }, //timelimitsummary_form_type
    update_timelimitsummary_form: (state, action) => {
      state.timelimitsummary_form_type = {
        ...state.timelimitsummary_form_type,
        ...action.payload,
      };
    }, //purchasepreparelist_form_type
    update_purchasepreparelist_form: (state, action) => {
      state.purchasepreparelist_form_type = {
        ...state.purchasepreparelist_form_type,
        ...action.payload,
      };
    }, //schoolattlist_form_type
    update_schoolattlist_form: (state, action) => {
      state.schoolattlist_form_type = {
        ...state.schoolattlist_form_type,
        ...action.payload,
      };
    }, //livingarrangement_form_type
    update_livingarrangement_form: (state, action) => {
      state.livingarrangement_form_type = {
        ...state.livingarrangement_form_type,
        ...action.payload,
      };
    }, //noncustparentlist_form_type
    update_noncustparentlist_form: (state, action) => {
      state.noncustparentlist_form_type = {
        ...state.noncustparentlist_form_type,
        ...action.payload,
      };
    }, //medcondlist_form_type
    update_medcondlist_form: (state, action) => {
      state.medcondlist_form_type = {
        ...state.medcondlist_form_type,
        ...action.payload,
      };
    }, //emplistinclist_form_type
    update_emplistinclist_form: (state, action) => {
      state.emplistinclist_form_type = {
        ...state.emplistinclist_form_type,
        ...action.payload,
      };
    }, //resourcelist_form_type
    update_resourcelist_form: (state, action) => {
      state.resourcelist_form_type = {
        ...state.resourcelist_form_type,
        ...action.payload,
      };
    }, //expenselist_form_type
    update_expenselist_form: (state, action) => {
      state.expenselist_form_type = {
        ...state.expenselist_form_type,
        ...action.payload,
      };
    }, //dcexpenselist_form_type
    update_dcexpenselist_form: (state, action) => {
      state.dcexpenselist_form_type = {
        ...state.dcexpenselist_form_type,
        ...action.payload,
      };
    }, //mdexpenselist_form_type
    update_mdexpenselist_form: (state, action) => {
      state.mdexpenselist_form_type = {
        ...state.mdexpenselist_form_type,
        ...action.payload,
      };
    }, //mdcareexpenselist_form_type
    update_mdcareexpenselist_form: (state, action) => {
      state.mdcareexpenselist_form_type = {
        ...state.mdcareexpenselist_form_type,
        ...action.payload,
      };
    }, //childcareneedlist_form_type
    update_childcareneedlist_form: (state, action) => {
      state.childcareneedlist_form_type = {
        ...state.childcareneedlist_form_type,
        ...action.payload,
      };
    }, //pcscheduledlist_form_type
    update_pcscheduledlist_form: (state, action) => {
      state.pcscheduledlist_form_type = {
        ...state.pcscheduledlist_form_type,
        ...action.payload,
      };
    }, //famplanchildcare_form_type
    update_famplanchildcare_form: (state, action) => {
      state.famplanchildcare_form_type = {
        ...state.famplanchildcare_form_type,
        ...action.payload,
      };
    }, //tanfsuspensionbased_form_type
    update_tanfsuspensionbased_form: (state, action) => {
      state.tanfsuspensionbased_form_type = {
        ...state.tanfsuspensionbased_form_type,
        ...action.payload,
      };
    }, //dvsass_form_type
    update_dvsass_form: (state, action) => {
      state.dvsass_form_type = {
        ...state.dvsass_form_type,
        ...action.payload,
      };
    }, //icebt_form_type
    update_icebt_form: (state, action) => {
      state.icebt_form_type = {
        ...state.icebt_form_type,
        ...action.payload,
      };
    }, //expeditedstatus_form_type
    update_expeditedstatus_form: (state, action) => {
      state.expeditedstatus_form_type = {
        ...state.expeditedstatus_form_type,
        ...action.payload,
      };
    }, //icmawrs_form_type
    update_icmawrs_form: (state, action) => {
      state.icmawrs_form_type = {
        ...state.icmawrs_form_type,
        ...action.payload,
      };
    }, //verificationslist_form_type
    update_verificationslist_form: (state, action) => {
      state.verificationslist_form_type = {
        ...state.verificationslist_form_type,
        ...action.payload,
      };
    }, //todo_form_type
    update_todo_form: (state, action) => {
      state.todo_form_type = {
        ...state.todo_form_type,
        ...action.payload,
      };
    }, //runedbc_form_type
    update_runedbc_form: (state, action) => {
      state.runedbc_form_type = {
        ...state.runedbc_form_type,
        ...action.payload,
      };
    }, //narrative_form_type
    update_narrative_form: (state, action) => {
      state.narrative_form_type = {
        ...state.narrative_form_type,
        ...action.payload,
      };
    },
    update_alert_msg: (state, action) => {
      state.alert_msg = {
        ...state.alert_msg,
        ...action.payload,
      };
    },
    set_agent_name: (state, action) => {
      state.agent_name = action.payload;
    },
    // update_interview_form_data: (state, action) => {
    //   state.interview_form_data.push(action.payload);
    // },
    setErrorCount_answer_call_form: (state, action) => {
      state.answer_call_form_type.errorCount = action.payload;
    },
    setErrorCount_right_resp_form: (state, action) => {
      state.right_resp_form_type.errorCount = action.payload;
    },
    setErrorCount_registration_form: (state, action) => {
      state.registration_form_type.errorCount = action.payload;
    },
    setErrorCount_tanfdt_form: (state, action) => {
      state.tanfdt_form_type.errorCount = action.payload;
    },
    setErrorCount_tanfwpcoop_form: (state, action) => {
      state.tanfwpcoop_form_type.errorCount = action.payload;
    },
    setErrorCount_childcareonly_form: (state, action) => {
      state.childcareonly_form_type.errorCount = action.payload;
    },
    setErrorCount_cctanf_form: (state, action) => {
      state.cctanf_form_type.errorCount = action.payload;
    },
    setErrorCount_screenvr_form: (state, action) => {
      state.screennamevr_form_type.errorCount = action.payload;
    },
    setErrorCount_screenpw_form: (state, action) => {
      state.screennamepw_form_type.errorCount = action.payload;
    },
    setErrorCount_csallprograms_form: (state, action) => {
      state.csallprograms_form_type.errorCount = action.payload;
    },
    setErrorCount_csauthrep_form: (state, action) => {
      state.csauthrep_form_type.errorCount = action.payload;
    },
    setErrorCount_cssummaryscreen_form: (state, action) => {
      state.cssummaryscreen_form_type.errorCount = action.payload;
    }, //reportingpage_form_type
    setErrorCount_reportingpage_form: (state, action) => {
      state.reportingpage_form_type.errorCount = action.payload;
    }, //indemoscreen_form_type
    setErrorCount_indemoscreen_form: (state, action) => {
      state.indemoscreen_form_type.errorCount = action.payload;
    }, //citidentitylist_form_type
    setErrorCount_citidentitylist_form: (state, action) => {
      state.citidentitylist_form_type.errorCount = action.payload;
    }, //householdstatuslist_form_type
    setErrorCount_householdstatuslist_form: (state, action) => {
      state.householdstatuslist_form_type.errorCount = action.payload;
    }, //relationshiplist_form_type
    setErrorCount_relationshiplist_form: (state, action) => {
      state.relationshiplist_form_type.errorCount = action.payload;
    }, //pregnancylist_form_type
    setErrorCount_pregnancylist_form: (state, action) => {
      state.pregnancylist_form_type.errorCount = action.payload;
    }, //otherprogramlist_form_type
    setErrorCount_otherprogramlist_form: (state, action) => {
      state.otherprogramlist_form_type.errorCount = action.payload;
    }, //noncompliancelist_form_type
    setErrorCount_noncompliancelist_form: (state, action) => {
      state.noncompliancelist_form_type.errorCount = action.payload;
    }, //timelimitsummary_form_type
    setErrorCount_timelimitsummary_form: (state, action) => {
      state.timelimitsummary_form_type.errorCount = action.payload;
    }, //purchasepreparelist_form_type
    setErrorCount_purchasepreparelist_form: (state, action) => {
      state.purchasepreparelist_form_type.errorCount = action.payload;
    }, //schoolattlist_form_type
    setErrorCount_schoolattlist_form: (state, action) => {
      state.schoolattlist_form_type.errorCount = action.payload;
    }, //livingarrangement_form_type
    setErrorCount_livingarrangement_form: (state, action) => {
      state.livingarrangement_form_type.errorCount = action.payload;
    }, //noncustparentlist_form_type
    setErrorCount_noncustparentlist_form: (state, action) => {
      state.noncustparentlist_form_type.errorCount = action.payload;
    }, //medcondlist_form_type
    setErrorCount_medcondlist_form: (state, action) => {
      state.medcondlist_form_type.errorCount = action.payload;
    }, //emplistinclist_form_type
    setErrorCount_emplistinclist_form: (state, action) => {
      state.emplistinclist_form_type.errorCount = action.payload;
    }, //resourcelist_form_type
    setErrorCount_resourcelist_form: (state, action) => {
      state.resourcelist_form_type.errorCount = action.payload;
    }, //expenselist_form_type
    setErrorCount_expenselist_form: (state, action) => {
      state.expenselist_form_type.errorCount = action.payload;
    }, //dcexpenselist_form_type
    setErrorCount_dcexpenselist_form: (state, action) => {
      state.dcexpenselist_form_type.errorCount = action.payload;
    }, //mdexpenselist_form_type
    setErrorCount_mdexpenselist_form: (state, action) => {
      state.mdexpenselist_form_type.errorCount = action.payload;
    }, //mdcareexpenselist_form_type
    setErrorCount_mdcareexpenselist_form: (state, action) => {
      state.mdcareexpenselist_form_type.errorCount = action.payload;
    }, //childcareneedlist_form_type
    setErrorCount_childcareneedlist_form: (state, action) => {
      state.childcareneedlist_form_type.errorCount = action.payload;
    }, //pcscheduledlist_form_type
    setErrorCount_pcscheduledlist_form: (state, action) => {
      state.pcscheduledlist_form_type.errorCount = action.payload;
    }, //famplanchildcare_form_type
    setErrorCount_famplanchildcare_form: (state, action) => {
      state.famplanchildcare_form_type.errorCount = action.payload;
    }, //tanfsuspensionbased_form_type
    setErrorCount_tanfsuspensionbased_form: (state, action) => {
      state.tanfsuspensionbased_form_type.errorCount = action.payload;
    }, //dvsass_form_type
    setErrorCount_dvsass_form: (state, action) => {
      state.dvsass_form_type.errorCount = action.payload;
    }, //icebt_form_type
    setErrorCount_icebt_form: (state, action) => {
      state.icebt_form_type.errorCount = action.payload;
    }, //expeditedstatus_form_type
    setErrorCount_expeditedstatus_form: (state, action) => {
      state.expeditedstatus_form_type.errorCount = action.payload;
    }, //icmawrs_form_type
    setErrorCount_icmawrs_form: (state, action) => {
      state.icmawrs_form_type.errorCount = action.payload;
    }, //verificationslist_form_type
    setErrorCount_verificationslist_form: (state, action) => {
      state.verificationslist_form_type.errorCount = action.payload;
    }, //todo_form_type
    setErrorCount_todo_form: (state, action) => {
      state.todo_form_type.errorCount = action.payload;
    }, //runedbc_form_type
    setErrorCount_runedbc_form: (state, action) => {
      state.runedbc_form_type.errorCount = action.payload;
    }, //narrative_form_type
    setErrorCount_narrative_form: (state, action) => {
      state.narrative_form_type.errorCount = action.payload;
    },
  },
});
export const {
  update_alert_msg,
  update_answer_call_form,
  update_right_resp_form,
  update_registration_form,
  update_tanfdt_form,
  update_tanfwpcoop_form,
  update_childcareonly_form,
  update_cctanf_form,
  update_screenvr_form,
  update_screenpw_form,
  update_csallprograms_form,
  update_csauthrep_form,
  update_cssummaryscreen_form,
  update_reportingpage_form,
  update_indemoscreen_form,
  update_citidentitylist_form,
  update_householdstatuslist_form,
  update_relationshiplist_form,
  update_pregnancylist_form,
  update_otherprogramlist_form,
  update_noncompliancelist_form,
  update_timelimitsummary_form,
  update_purchasepreparelist_form,
  update_schoolattlist_form,
  update_livingarrangement_form,
  update_noncustparentlist_form,
  update_medcondlist_form,
  update_emplistinclist_form,
  update_resourcelist_form,
  update_expenselist_form,
  update_dcexpenselist_form,
  update_mdexpenselist_form,
  update_mdcareexpenselist_form,
  update_childcareneedlist_form,
  update_pcscheduledlist_form,
  update_famplanchildcare_form,
  update_tanfsuspensionbased_form,
  update_dvsass_form,
  update_icebt_form,
  update_expeditedstatus_form,
  update_icmawrs_form,
  update_verificationslist_form,
  update_todo_form,
  update_runedbc_form,
  update_narrative_form,
  update_interview_form_data,
  update_temp_data_form_type,
  update_pdf_files_type,
  update_pdf_data_list,
  update_isSuccess,
  set_agent_name,
  setErrorCount_answer_call_form,
  setErrorCount_right_resp_form,
  setErrorCount_registration_form,
  setErrorCount_tanfdt_form,
  setErrorCount_tanfwpcoop_form,
  setErrorCount_childcareonly_form,
  setErrorCount_cctanf_form,
  setErrorCount_screenvr_form,
  setErrorCount_screenpw_form,
  setErrorCount_csallprograms_form,
  setErrorCount_csauthrep_form,
  setErrorCount_cssummaryscreen_form,
  setErrorCount_reportingpage_form,
  setErrorCount_indemoscreen_form,
  setErrorCount_citidentitylist_form,
  setErrorCount_householdstatuslist_form,
  setErrorCount_relationshiplist_form,
  setErrorCount_pregnancylist_form,
  setErrorCount_otherprogramlist_form,
  setErrorCount_noncompliancelist_form,
  setErrorCount_timelimitsummary_form,
  setErrorCount_purchasepreparelist_form,
  setErrorCount_schoolattlist_form,
  setErrorCount_livingarrangement_form,
  setErrorCount_noncustparentlist_form,
  setErrorCount_medcondlist_form,
  setErrorCount_emplistinclist_form,
  setErrorCount_resourcelist_form,
  setErrorCount_expenselist_form,
  setErrorCount_dcexpenselist_form,
  setErrorCount_mdexpenselist_form,
  setErrorCount_mdcareexpenselist_form,
  setErrorCount_childcareneedlist_form,
  setErrorCount_pcscheduledlist_form,
  setErrorCount_famplanchildcare_form,
  setErrorCount_tanfsuspensionbased_form,
  setErrorCount_dvsass_form,
  setErrorCount_icebt_form,
  setErrorCount_expeditedstatus_form,
  setErrorCount_icmawrs_form,
  setErrorCount_verificationslist_form,
  setErrorCount_todo_form,
  setErrorCount_runedbc_form,
  setErrorCount_narrative_form,
} = trackerSlice.actions;
export default trackerSlice.reducer;
